import { useEffect } from "react";

import { GrowthBookType } from "@/src/type/growthbook";
import { FrontendTrackingService } from "@/src/service";

interface VariantTrackingProps {
  growthbook: GrowthBookType.GrowthBookAndContentVariants;
}

function VariantTracking({ growthbook }: VariantTrackingProps) {
  useEffect(() => {
    if (!growthbook?.experiments) {
      return;
    }

    for (const [experimentKey, experimentVariant] of Object.entries(growthbook.experiments ?? {})) {
      FrontendTrackingService.postTrackingLog({
        action: "variant_test_active",
        actionCategory: "variant_test",
        actionIdType: "experimentKey",
        actionId: experimentKey,
        actionMessage: "Variants initiated",
        triggeredFrom: "VariantTracking.tsx:(useEffect variant test active)",
        variant: experimentVariant,
        variantExperimentKey: experimentKey,
        variantProject: "flow.life",
      });
    }
  }, [growthbook]);
  return <></>;
}

export default VariantTracking;
